import React from 'react'
import { Form, FormControl, Col, Image } from 'react-bootstrap'

/**
 * View to display the editing forms of an articleType
 * @param {object} articleType articleType to be edited
 * @param {any} handleSubmit handles the submit of edited articlType values
 */
const UpdateArticleTypeView = ({ articleType, handleSubmit }) => {
    let name
    let articleNumber
    let gender
    let description
    let colour
    let price
    let salePrice

    /**
     * Creates an articleType object via ref values.
     * @param {any} e button submit default event
     */
    const handleValueInput = (e) => {
        e.preventDefault()

        const articleTypeToUpdate = {
            Name: name.value,
            ArticleNumberDesigner: articleNumber.value,
            DescriptionDesigner: description.value,
            Colour: colour.value,
            Gender: gender.value,
            SizeCat: articleType.SizeAttribute.SizeCategory,
            Price: price.value,
            SalePrice: salePrice.value,
            LabelArticleTypeId: articleType.ArticleTypeSysId,
        }
        handleSubmit(articleTypeToUpdate)
    }

    return (
        <div lang="de">
            <Form onSubmit={handleValueInput} id='update-article-form'>
                <Form.Group controlId="article-select">

                    <div className="controlTitle">{window.i18n('articleNumber') + ":"}</div>
                    <FormControl required className="form" as="input" defaultValue={articleType.ArticleNumberDesigner} ref={node => articleNumber = node}></FormControl>

                    <div className="controlTitle">{window.i18n('name') + ":"}</div>
                    <FormControl required className="form" as="input" defaultValue={articleType.Name} ref={node => name = node}></FormControl>

                    <div className="controlTitle">{window.i18n('description') + ":"}</div>
                    <FormControl className="form" as="textarea" defaultValue={articleType.DescriptionDesigner} ref={node => description = node} ></FormControl>

                    <div className="controlTitle">{window.i18n('colour') + ":"}</div>
                    <FormControl required className="form" as="textarea" defaultValue={articleType.ColourDescription.ColourName} placeholder={window.i18n('colour') + "..."} ref={node => colour = node}></FormControl>

                    <div className="controlTitle">{window.i18n('gender') + ":"}</div>
                    <FormControl disabled as="select" defaultValue={articleType.Sexes} className="form"
                        focusFirstItemOnShow='keyboard' ref={node => gender = node}>
                        <option disabled value={articleType.Sexes}>{articleType.Sexes}</option>
                    </FormControl>

                    <div className="controlTitle">{window.i18n('sizeCategory') + ":"}</div>
                    <FormControl disabled as="select" className="form"
                        focusFirstItemOnShow='keyboard' >
                        <option>{articleType.SizeAttribute.SizeCategory}</option>
                    </FormControl>

                    <div className="controlTitle">{window.i18n('salePrice') + ":"}</div>
                    <Form.Row size="sm" className="input-currency">
                        <Col><FormControl required className="form" type="number" min="0.00" step="0.01" defaultValue={articleType.SalePrice} ref={node => salePrice = node}></FormControl> </Col>
                        <Col> <p className="input-currency-symbol">€</p> </Col>
                    </Form.Row>

                    <div className="controlTitle">{window.i18n('purchasePrice') + ":"}</div>
                    <Form.Row size="sm" className="input-currency">
                        <Col><FormControl required className="form" type="number" min="0.00" step="0.01" defaultValue={articleType.Price} ref={node => price = node}></FormControl> </Col>
                        <Col> <p className="input-currency-symbol">€</p> </Col>
                    </Form.Row>

                    <Form inline>
                        <Image className="thumbnail" src={articleType.articleImage} />
                    </Form>

                </Form.Group>
            </Form>
        </div>
    )
}

export { UpdateArticleTypeView }